<template>
  <v-col cols="9" xs="9" sm="10" md="10" lg="10" class="val-area">
    <v-row>
      <v-col cols="3" xs="3" sm="3" md="3" lg="3">
        <p class="val-text">{{numVal}}{{unit}}</p>
      </v-col>
      <v-col cols="9" xs="9" sm="9" md="9" lg="9">
        <v-btn color="#fff" rounded depressed height="30s" class="detail-btn" @click="clickAction">
          <p class="btn-text">くわしく見る</p>
        </v-btn>
      </v-col>
    </v-row>
  </v-col>
  <!-- </v-row> -->
</template>

<script>
export default {
  name: "TopParam",
  data: () => ({}),
  methods: {
    clickAction() {
      this.$emit('clickAction')
    }
  },
  props:['numVal', 'unit']
};
</script>

<style scoped>
p {
  margin: 0;
  vertical-align: middle;
}
.val-area {
  padding: 0 12px 0 12px;
}
.val-text {
  color: #fff;
  font-weight: bold;
  font-size: 1.5em;
  padding: 2px 0 0 0;
}
.detail-btn {
  border-style: none;
  padding: 0 0 50px 0;
  font-size: 0.7em;
}
.btn-text {
  font-weight: bold;
  font-size: 1.5em;
  color: #74b8be;
}
@media screen and (max-width: 350px) {
  .val-text {
    font-size: 1.2em;
    padding: 5px 0;
  }
  .btn-text {
    font-size: 1em;
  }
}
@media screen and (min-width: 351px) and (max-width: 768px) {
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
}
@media screen and (min-width: 1024px) {
}
</style>
